module.exports = __webpack_public_path__ + "static/attachment01-e409b13c9f7a458fa3584fb41e5d7c6f.jpg";